import Link from 'next/link';

import styles from 'global/styles/Contacts.module.scss';

import { Breadcrumbs, BreadcrumbType } from 'app/shared';
import StaticPagesMenu from '../components/StaticPages/Menu';

const breadcrumbs: BreadcrumbType[] = [
  {
    title: 'Документы ООО Макрохим',
    href: '/documents',
  },
];

export default function Documents() {
  return (
    <div>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className={`${styles.staticPage} container`}>
        <StaticPagesMenu />
        <div className={styles.staticPageContent}>
          <h1 className={styles.staticPageTitle}>Документы ООО Макрохим</h1>
          <div className={styles.staticPageInfo}>
            <div className={styles.staticPageText}>
              1.{' '}
              <Link href="/docs/policy.pdf" className={`${styles.staticPageText} ${styles.link}`} target="_blank">
                Политика конфиденциальности
              </Link>
            </div>
            <div className={styles.staticPageText}>
              2.{' '}
              <Link href="/docs/terms_of_use.pdf" className={`${styles.staticPageText} ${styles.link}`} target="_blank">
                Пользовательское соглашение
              </Link>
            </div>
            <div className={styles.staticPageText}>
              3.{' '}
              <Link href="/docs/shopping.pdf" className={`${styles.staticPageText} ${styles.link}`} target="_blank">
                Условия покупки товаров
              </Link>
            </div>
            <div className={styles.staticPageText}>
              4.{' '}
              <Link href="/docs/return.pdf" className={`${styles.staticPageText} ${styles.link}`} target="_blank">
                Памятка по&nbsp;возврату
              </Link>
            </div>
            <div className={styles.staticPageText}>
              5.{' '}
              <Link href="/docs/form_return.pdf" className={`${styles.staticPageText} ${styles.link}`} target="_blank">
                Бланк заявления на&nbsp;возврат
              </Link>
            </div>
            <div className={styles.staticPageText}>
              6.{' '}
              <Link
                href="/docs/license_partners.pdf"
                className={`${styles.staticPageText} ${styles.link}`}
                target="_blank"
              >
                Лицензия (Правила использования для партнёров)
              </Link>
            </div>
            <div className={styles.staticPageText}>
              7.{' '}
              <Link
                href="/docs/rules_delivery.pdf"
                className={`${styles.staticPageText} ${styles.link}`}
                target="_blank"
              >
                Правила маркировки, хранения и&nbsp;доставки
              </Link>
            </div>
            <div className={styles.staticPageText}>
              8.{' '}
              <Link
                href="/docs/uslovia_hranenia_tovarov.pdf"
                className={`${styles.staticPageText} ${styles.link}`}
                target="_blank"
              >
                Условия хранения товаров
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
